import React from "react";
import { Button } from "react-bootstrap";

import LoadingButton from "../components/LoadingButton";

const EntryButtons = ({ onCancel, onDelete, loading, noDelete, ...props }) => {
  return (
    <div className="d-flex justify-content-between">
      <div>
      {!noDelete &&
      <Button variant="danger" onClick={onDelete} disabled={loading}>
        Delete
      </Button>
      }
      </div>
      <div>
        <Button
          variant="secondary"
          className="mr-2"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <LoadingButton isLoading={loading} variant="primary" type="submit">
          Update
        </LoadingButton>
      </div>
    </div>
  );
};

export default EntryButtons;
